import { useSelector } from 'react-redux';
import store from './index';

export type RootState = ReturnType<typeof store.getState>;

export function useSelectorTyped<T>(
  fn: (arg: RootState) => T,
  equalityFn?: (a: T, b: T) => boolean
) {
  return useSelector<RootState, T>(fn, equalityFn);
}
